/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_TabInputs */

const en_seller_calendar_tab = /** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar & Bookings`)
};

const es_seller_calendar_tab = /** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario y Reservas`)
};

const fr_seller_calendar_tab = /** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendrier et Réservations`)
};

const de_seller_calendar_tab = /** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender & Buchungen`)
};

const id_seller_calendar_tab = /** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender & Pemesanan`)
};

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const ja_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const zh_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const ar_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const it_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const ru_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const pt_seller_calendar_tab = en_seller_calendar_tab;

/** @type {(inputs: Seller_Calendar_TabInputs) => LocalizedString} */
const ko_seller_calendar_tab = en_seller_calendar_tab;

/**
* | output |
* | --- |
* | "Calendar & Bookings" |
*
* @param {Seller_Calendar_TabInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_tab = /** @type {((inputs?: Seller_Calendar_TabInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_TabInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_tab(inputs)
	if (locale === "es") return es_seller_calendar_tab(inputs)
	if (locale === "fr") return fr_seller_calendar_tab(inputs)
	if (locale === "de") return de_seller_calendar_tab(inputs)
	if (locale === "ja") return ja_seller_calendar_tab(inputs)
	if (locale === "zh") return zh_seller_calendar_tab(inputs)
	if (locale === "ar") return ar_seller_calendar_tab(inputs)
	if (locale === "id") return id_seller_calendar_tab(inputs)
	if (locale === "it") return it_seller_calendar_tab(inputs)
	if (locale === "ru") return ru_seller_calendar_tab(inputs)
	if (locale === "pt") return pt_seller_calendar_tab(inputs)
	return ko_seller_calendar_tab(inputs)
});